module.exports = __webpack_public_path__ + "img/zuoban.prt.fa3cdf45.jpg";